const footer = (): void => {
  const classes = {
    footerModalActive: 'footer__modal--active',
    footerModalOverlayActive: 'footer__modal-overlay--active',
  };

  const selectors = {
    footerModal: '[data-footer-modal]',
    footerModalToggle: '[data-footer-modal-toggle]',
    footerModalOverlay: '[data-footer-modal-overlay]',
  };

  const footerModal = document.querySelector(selectors.footerModal);
  const footerModalOverlay = document.querySelector(
    selectors.footerModalOverlay
  );
  const footerModalToggles = document.querySelectorAll(
    selectors.footerModalToggle
  );

  if (footerModal && footerModalOverlay && footerModalToggles) {
    footerModalToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        footerModal.classList.toggle(classes.footerModalActive);
        footerModalOverlay.classList.toggle(classes.footerModalOverlayActive);
      });
    });
  }
};

export default footer;
